/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  AutocompleteClearButton component
 */

import { Clear } from '@zcode-ui/icons'
import React, { useCallback } from 'react'
import { a11yButtonHandler } from '../../../../shared/utils/a11y'
import { useAutocompleteContext } from '../AutocompleteContext'
import type { AutocompleteTheme } from '../constants'

export interface AutocompleteClearButtonProps {
  isMapListNav?: boolean
  resetForm?: () => void
  setFieldValue?: (field: 'searchTerm', value: string, validate?: boolean | undefined) => void
  theme: AutocompleteTheme
}

export const AutocompleteClearButton = ({
  isMapListNav,
  resetForm,
  setFieldValue,
  theme,
}: AutocompleteClearButtonProps) => {
  const { setForceContextualMenuOpen, setIsFocused, setPredictionResults, setSearchTerm } =
    useAutocompleteContext()

  const onClickClear = useCallback(() => {
    if (isMapListNav && setFieldValue) {
      setFieldValue('searchTerm', '')
      return
    }
    setForceContextualMenuOpen(true)
    resetForm?.()
    setPredictionResults(null)
    setSearchTerm('')
    setTimeout(() => {
      setIsFocused(true)
      setForceContextualMenuOpen(false)
    })
  }, [
    isMapListNav,
    setFieldValue,
    setForceContextualMenuOpen,
    setPredictionResults,
    setIsFocused,
    setSearchTerm,
    resetForm,
  ])

  return (
    <button
      aria-label="clear input"
      className={theme.closeButton}
      onClick={onClickClear}
      onKeyPress={a11yButtonHandler(onClickClear)}
      type="button"
    >
      <Clear size={20} />
    </button>
  )
}
